<div
  class="container-btn tw-relative tw-flex tw-w-full tw-items-center tw-justify-center"
  (click)="onButtonClick()"
>
  <div class="tw-absolute tw-left-0 tw-top-0 tw-z-3 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
    <ng-content></ng-content>
  </div>
  <img
    class="button tw-h-auto tw-w-full"
    [src]="'/cybermonth/buttons/button.webp' | staticUrl"
    alt="cyber-button"
  />
  <img
    class="button-hover tw-absolute tw-left-1/2 tw-top-1/2 tw-z-2 tw-h-auto tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2"
    [src]="'/cybermonth/buttons/button_hover.webp' | staticUrl"
    alt="cyber-button"
  />
  <img
    class="button-done tw-absolute tw-left-1/2 tw-top-1/2 tw-z-2 tw-h-auto tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2"
    [src]="'/cybermonth/buttons/button_done.webp' | staticUrl"
    alt="cyber-button"
  />
</div>
